const ProfileEnum = {
  ADMINISTRADOR: '1',
  PREENCHIMENTO: '2',
  APROVADOR: '3',
}

export default ProfileEnum
